export class AddCandidatesPageController {
    /*@ngInject*/
    constructor($state, MESSAGECONSTANTS) {
        this.$state = $state;
        this.MESSAGECONSTANTS = MESSAGECONSTANTS;
    }
    $onInit() {
        this.$stateParams = this.$transition$.params();
    }
    saveCallback() {
        this.$state.go('missioncontrol.candidates');
    }
}
AddCandidatesPageController.$inject = ['$state', 'MESSAGECONSTANTS'];
// import * as TEMPLATE from './add-candidates-page.html';
import * as TEMPLATE from 'raw-loader!./add-candidates-page.html';
export const AddCandidatesPageComponent = {
    selector: 'addCandidatesPage',
    component: {
        bindings: { $transition$: '<' },
        template: TEMPLATE.default,
        // templateUrl: 'app/partials/missioncontrol/addCandidates/add-candidates-page.html',
        controller: AddCandidatesPageController
    }
};
//# sourceMappingURL=add-candidates-page.component.js.map